const data = {
  hero: {
    heading: "Women's \nHealth Survey \n2023",
    title:
      "More than 1 in 5 Indian women suffer from health conditions arising from hormonal imbalances, ",
    description:
      "but have limited knowledge, awareness & support to manage their symptoms and condition. Menstrual health, and life stage events such as pregnancies & menopause also bring their fair share of challenges. This also manifests at work, where corporate India faces significant difficulties in acknowledging and addressing women's health issues.",
  },
  benefits: {
    heading:
      "At Shyft, we believe that the first step to solving these issues is to understand them deeply. We're undertaking this survey to",
    benefits: [
      {
        icon: "icon-whs-benefits-1",
        title:
          "Gather accurate information around gaps in support and awareness in women's health.",
      },
      {
        icon: "icon-whs-benefits-2",
        title:
          "Collaborate with key stakeholders in corporate & urban India to drive awareness & change.",
      },
      {
        icon: "icon-whs-benefits-3",
        title:
          "Implement improved solutions to drive better health outcomes for women.",
      },
    ],
  },
  actions: {
    primaryCTA: {
      text: "Participate in the Survey",
    },
    banner: {
      prefix: "Join us in taking the first crucial step",
      heading: "The change begins with you!",
      content: {
        title:
          "If you are an HR and want to roll out this survey to your organization, please share your details.",
        secondaryCTA: {
          text: "Submit details",
        },
      },
    },
  },
  partners: {
    heading: "Our Partners",
    partners: [
      {
        name: "KPMG",
        logo: "icon-whs-partners-kpmg",
        width: "2.0234375em",
        height: "1em",
        fontSize: "32.6px",
      },
      {
        name: "TATA",
        logo: "icon-whs-partners-tata",
        width: "1.142578125em",
        height: "1em",
        fontSize: "34px",
      },
      {
        name: "eyowo",
        logo: "icon-whs-partners-eyowo",
        width: "4em",
        height: "1em",
        fontSize: "24.9px",
      },
      {
        name: "Zomato",
        logo: "icon-whs-partners-zomato",
        width: "4.6796875em",
        height: "1em",
        fontSize: "24.4px",
      },
      {
        name: "Ernst & Young",
        logo: "icon-whs-partners-ernst-and-young",
        width: "3.4765625em",
        height: "1em",
        fontSize: "32.6px",
      },
      {
        name: "STARBUCKS",
        logo: "icon-whs-partners-starbucks",
        width: "2.0712890625em",
        height: "1em",
        fontSize: "41.4px",
      },
      {
        name: "FedEx",
        logo: "icon-whs-partners-fedex",
        width: "2.7138671875em",
        height: "1em",
        fontSize: "41.4",
      },
    ],
  },
  faqs: {
    heading: "Frequently Asked Questions",
    faqs: [
      {
        question: "Why is Shyft conducting this survey?",
        answer:
          "Shyft is undertaking this research to <br />- Gather accurate information around gaps in support and awareness in women's health<br />- Collaborate with key stakeholders in corporate & urban India to drive awareness & change<br />- Implement improved solutions to drive better health outcomes for women",
      },
      {
        question: "What is the methodology for this survey?",
        answer:
          "This is a rolling survey where we will continue to collect responses for the entire year. Results will be published and shared periodically with all respondents.",
      },
      {
        question: "How much time will it take to fill the survey?",
        answer:
          "The estimated time to complete the survey is between 5-8 minutes, depending on your responses.",
      },
      {
        question: "How will the survey results be used?",
        answer:
          "Respondent privacy is of prime importance for the survey. Responses will be used in aggregated form only, for research and marketing purposes.",
      },
      {
        question:
          "What is the eligibility criteria to participate in the survey?",
        answer:
          "The survey is open to men and women between the ages of 21 and 55 years. There is no other criteria for eligibility.",
      },
    ],
  },
};

export default data;
